/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Query } from '../models/query';
export interface LookupConfiguration {
  filter?: Query;
  viewCode?: string | null;
}

export class LookupConfiguration {
  filter?: Query;
  viewCode?: string | null;

  constructor(value: LookupConfiguration) {
    this.filter = value?.filter ? new Query(value.filter) : undefined;
    this.viewCode = value?.viewCode;
  }
}
